import { isDefined } from '@sgme/fp';
import { Tooltip } from '@sgme/ui';
import { Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import { OptionFormGroup } from '@/App/tiles/Option/fields/OptionFormGroup.tsx';
import { useOptionSelector } from '@/App/tiles/Option/OptionContext.ts';
import { useCheckOption } from '@/App/tiles/Option/QueueContext.tsx';
import { selectOptionCurrency } from '@/store/option/selectors/optionSelectors.ts';

export const FixingReference1 = () => {
  const {
    tileId,
    fixingReference1,
    fixingReference1List,
    fixingReference1Default,
    crossCurrency,
    currency: { currency1, currency2, currencyPair },
  } = useOptionSelector((option) => ({
    fixingReference1: option.properties.fixingReference1,
    fixingReference1Default: option.properties.fixingReference1Default,
    fixingReference1List: option.properties.fixingReference1List,
    crossCurrency: option.properties.crossCurrency,
    currency: selectOptionCurrency(option),
    tileId: option.properties.tileId,
  }));

  const [checkOption] = useCheckOption();

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    return checkOption({
      tileId,
      properties: {
        fixingReference1: event.target.value,
      },
    });
  };

  const isSameReferenceAsDefault = fixingReference1 === fixingReference1Default;
  const isCrossCurrency = isDefined(crossCurrency) && crossCurrency !== currency2 && crossCurrency !== currency1;
  const currencyPairDisplayed = isCrossCurrency ? `${currency1}/${crossCurrency}` : currencyPair;

  return (
    <OptionFormGroup
      label={
        <FormattedMessage
          id={'targetAccumulator.form.fixingReference'}
          values={{ currencyPair: currencyPairDisplayed ?? '' }}
        />
      }
      addon={
        !isSameReferenceAsDefault ? (
          <Tooltip
            position="right"
            contents={
              <FormattedMessage
                id="option.fields.fixingReference.info"
                values={{ defaultFixingReference: fixingReference1Default, br: <br /> }}
              />
            }
          >
            <div className="badge badge-dismissible">
              <em className="icon icon-sm cursor-default line-height-1 text-secondary">info_outline</em>
            </div>
          </Tooltip>
        ) : undefined
      }
    >
      <Form.Select
        value={fixingReference1 ?? fixingReference1Default}
        onChange={handleChange}
        className={`${!isSameReferenceAsDefault ? 'text-warning fw-bold' : ''}`}
        size="sm"
        data-e2e="fixing-reference1-selector"
      >
        {fixingReference1List?.map((ref) => (
          <option className="text-primary" key={ref} value={ref}>
            {ref}
          </option>
        ))}
      </Form.Select>
    </OptionFormGroup>
  );
};
